// extracted by mini-css-extract-plugin
module.exports = {"triggerCover":"VideoFile_triggerCover__2KKfy"};